<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Parent Corporations</div>
                </div>
                <div class="col-md-3 offset-md-3 text-right center">
                    <button type="submit" class="btn btn-primary btn-fill"
                            @click="createParentCorp()">Create Parent Corporation</button>
                </div>
            </div>
            <div class="table-responsive text-center">
                <l-table class="table table-light table-bordered table-hover"
                         :columns="parentCorps.columns" :data="parentCorps.data">
                    <template slot="table-row" v-if="parentCorps.data.length">
                        <tr v-for="(item, index) in parentCorps.data" :key="index">
                            <td>{{item.parentAccountId}}</td>
                          <td>{{item.name}}</td>
                          <td>{{item.description}}</td>
                          <td>{{item.csvCorporationNames}}</td>
                          <td>
                            <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                            <span class="badge badge-danger" v-else> Inactive </span>
                          </td>
                          <td>
                            <div class="btn-group" role="group">
                              <button class="btn btn-secondary btn-sm" @click="viewParentCorp(item)" v-tooltip.top-center="tooltips.view"><i class="fa fa-eye"></i></button>
                              <button class="btn btn-info btn-sm" @click="editParentCorp(item)" v-tooltip.top-center="tooltips.edit"><i class="fa fa-edit"></i></button>
                            </div>
                          </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const columns = ['Parent Id', 'Name', 'Description', 'Child Corporations', 'Active', 'Operations'];
    export default {
        name: 'ParentCorps1',
        components: {
            LTable,
        },
        data() {
        return {
            tooltips: {
                view: 'View',
                edit: 'Edit'
            },
          parentCorps: {
                columns: [...columns],
        data: []
    }
    }
    },
    methods: {
        fetch () {
            this.$store.dispatch('FETCH_PARENTCORPS')
                    .then((res) => {
                        this.parentCorps.data = res;
                        console.log('response', res)
                        console.log("this.parentCorps.data : ", this.parentCorps.data);
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
        },
        viewParentCorp(item){
            this.$store.commit('SET_SELECTED_PARENTCORP', item);
            this.$router.push({ name: 'Parent Corporation Details', params: { id:  item.parentAccountId}})
        },
        editParentCorp(item){
            this.$store.commit('SET_SELECTED_PARENTCORP', item);
            this.$router.push({ name: 'Edit Parent Corporation', params: { id: item.parentAccountId}});
        },
        createParentCorp(){
            this.$router.push({ name: 'Create Parent Corporation'})
        },
    },
    created() {
        this.fetch();
    },
    computed:{
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        }
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ParentCorps/ParentCorps.vue